import React from "react";

import { useHistory, useRouteMatch } from "react-router-dom";

import {
  Button,
  Grid,
  IconButton,
  Icons,
  Text,
} from "@pushpress/shared-components";

import { CalendarItemSessionTypes } from "../Calendar.utils";
import { isCypress } from "../../../utils/cypress";

interface CalendarItemsListHeaderProps {
  calendarItemType: CalendarItemSessionTypes;
}

function CalendarItemsListHeader({
  calendarItemType,
}: CalendarItemsListHeaderProps) {
  const routeMatch = useRouteMatch();
  const path = isCypress ? `/schedule/list` : routeMatch?.path;
  const history = useHistory();

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Text variant="heading-3">
            {calendarItemType === CalendarItemSessionTypes.Events
              ? "Events"
              : "Classes"}
          </Text>
        </Grid>
        <Grid item>
          <Grid container alignItems="center" spacing={3}>
            {calendarItemType === CalendarItemSessionTypes.Classes && (
              <Grid item>
                <IconButton
                  icon={Icons.NavIconSettings}
                  onClick={() => history.push("/schedule/class-types")}
                  tooltip="Setup"
                />
              </Grid>
            )}
            <Grid item>
              <Button
                text={
                  calendarItemType === CalendarItemSessionTypes.Events
                    ? "Event"
                    : "Class"
                }
                size="large"
                buttonType="primary"
                icon={Icons.Plus}
                iconLocation="left"
                onClick={() => {
                  if (calendarItemType === CalendarItemSessionTypes.Events) {
                    history.push(`${path}/create/event`);
                  } else {
                    history.push(`${path}/create/class`);
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default CalendarItemsListHeader;
